import {Typography} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import {FooterDesktop, FooterLink} from '@yandex-delivery/order-layout-blocks'
import React, {memo} from 'react'

import NavLinks from 'src/shared/components/footer-menu/NavLinks'
import ArrowCircle from 'src/shared/components/icons/ArrowCircle'
import ArrowSquare from 'src/shared/components/icons/ArrowSquare'
import ArrowSquareShort from 'src/shared/components/icons/ArrowSquareShort'
import Car from 'src/shared/components/icons/Car'
import Dashboard from 'src/shared/components/icons/Dashboard'
import Door from 'src/shared/components/icons/Door'
import YaLogo from 'src/shared/components/icons/YaLogo'
import {appConfig} from 'src/shared/config'
import {useAppConfigContext} from 'src/shared/contexts/AppConfigContext'

import {DEFAULT_LANGUAGE, DEFAULT_TLD} from '../defaults'
import boxSrc from './assets/box.gif'
import expressSrc from './assets/express.gif'
import thumbsUpSrc from './assets/thumb-up-w.gif'
import * as classes from './classes'
import {footerApp, footerLogo, legalLinks, navLinks, storeButtonTags} from './country-consts'

export const Footer = memo(function Footer(): React.ReactElement {
  const i18n = useI18n()
  const {lang, tld = 'ru'} = useAppConfigContext()
  const stores = storeButtonTags[lang] || storeButtonTags[DEFAULT_LANGUAGE]
  const links = legalLinks[tld] || legalLinks[DEFAULT_TLD]
  const app = footerApp[tld] || footerApp[DEFAULT_TLD]

  return (
    <FooterDesktop
      footerApp={{
        qr: <img alt="qr" className={classes.qr} height={160} loading="lazy" src={app.qr} width={160} />,
        stores: (
          <>
            <a href={app.buttons.appStore}>
              <img alt="" height={46} loading="lazy" src={stores.appStore} width={185} />
            </a>
            <a href={app.buttons.googlePlay}>
              <img alt="" height={46} loading="lazy" src={stores.googlePlay} width={185} />
            </a>
            <a href={app.buttons.appGallery}>
              <img alt="" height={46} loading="lazy" src={stores.appGallery} width={185} />
            </a>
          </>
        ),
      }}
      footerIcons={
        <>
          <YaLogo className={classes.icon} />
          <Car className={classes.icon} />
          <ArrowCircle className={classes.icon} />
          <img alt="" className={classes.icon} height={144} loading="lazy" src={boxSrc} width={200} />
          <ArrowSquare className={classes.icon} />
          <Dashboard className={classes.icon} />
          <img alt="" className={classes.icon} height={85} loading="lazy" src={expressSrc} width={85} />
          <ArrowSquareShort className={classes.icon} />
          <Door className={classes.icon} />
          <img alt="" className={classes.icon} height={85} loading="lazy" src={thumbsUpSrc} width={85} />
        </>
      }
      footerLogo={footerLogo[tld] || footerLogo[DEFAULT_TLD]}
      legal={i18n(
        `order.footer.legal.${tld}`,
        'Яндекс.Доставка — услуги для юридических лиц. Яндекс Go — информационный сервис. Транспортные и иные услуги оказываются партнерами сервиса. Подробнее о тарифах Курьер, Доставка и Грузовой',
      )}
      legalLinks={
        <>
          {links.map(({label, ...other}) => (
            <FooterLink {...other} key={label}>
              {label}
            </FooterLink>
          ))}
        </>
      }
      navLinkList={<NavLinks navLinks={navLinks[tld] || navLinks[DEFAULT_TLD]} />}
      seoHeading={
        <Typography className={classes.seoHeading} color="invert" variant="header">
          {appConfig.seo?.heading ?? 'Рассчитайте стоимость доставки по городу'}
        </Typography>
      }
      storeDisclaimers={
        <>
          {i18n(
            'order.footer.disclaimer.google-play',
            'Google Play и логотип Google Play являются товарными знаками корпорации Google LLC.',
          )}
          <br />
          {i18n('order.footer.disclaimer.app-store', 'App Store является знаком обслуживания компании Apple Inc.')}
          <br />
          {i18n(
            'order.footer.disclaimer.app-gallery',
            'App Gallery, HUAWEI и логотип HUAWEI являются товарными знаками компании Huawei Technologies Co., Ltd.',
          )}
        </>
      }
    />
  )
})
